import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import {
  getCertificateTemplateByCompanyId,
  updateOrCreateCertificateTemplate,
} from './template.api';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';

export const useCertificateTemplateQuery = (company_id?: string, disabled?: boolean) => {
  return useQuery({
    queryKey: ['company-template', company_id],
    queryFn: company_id ? () => getCertificateTemplateByCompanyId(company_id) : skipToken,
    enabled: !!company_id && !disabled,
  });
};

export const useUpdateOrCreateCertificateTemplateMutation = () => {
  return useMutation({
    mutationKey: ['company-template', 'update'],
    mutationFn: ({ company_id, config }: { company_id: string; config: PDFStaticBuilderProps }) =>
      updateOrCreateCertificateTemplate(company_id, config),
  });
};
